import { BaseCellWrapper } from 'modules/experiments/components/takeover/styled';

export const BaseCell = ({
  value,
  isDisabled = false,
}: {
  value: string;
  isDisabled?: boolean;
}) => <BaseCellWrapper $isDisabled={isDisabled}>{value}</BaseCellWrapper>;
